export const FOCUS_BORDER_WIDTH = "2px"
export const ZINDEX_SELECT_LIST = 20
export const ZINDEX_SELECT_INPUT_FOCUSED = 30
export const ZINDEX_SELECT_LIST_FULLSCREEN = 100000
